import { createSlice } from "@reduxjs/toolkit";

const userModel = {
  lastname: "",
  firstname: "",
  isStudent: false,
};

export const userSlice = createSlice({
  name: "user",
  initialState: userModel,
  reducers: {
    setData: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});

// Action creators are generated for each case reducer function
export const { setData } = userSlice.actions;

export default userSlice.reducer;
